import { FC, Fragment } from 'react';

type AndListProps = {
  items: { url: string; text: string }[];
};

export const AndList: FC<AndListProps> = ({ items }) => {
  const length = items.length;
  return (
    <>
      {items.map((item, i) => {
        return (
          <Fragment key={i}>
            {i === 1 && length === 2
              ? ' & '
              : i === 0
                ? null
                : i === length - 1
                  ? ', and '
                  : ', '}
            <a href={item.url}>{item.text}</a>
          </Fragment>
        );
      })}
    </>
  );
};
